/** Asset catalog wire types, from the API contract (`src/api/generated`). */

import type {
  AssetCardOutput,
  AssetCreateIn,
  AssetListOutOutput,
  AssetOutOutput,
  AssetRefOutput,
  CatalogCardOutput,
  CatalogPersonOutput,
  CountryCountOutput,
  CountryTagOutput,
  ExpertOutOutput,
  FreshnessOutput,
  HistoryEventOutput,
  HistoryOutOutput,
  ListAssetsApiAssetsGetParams,
  RelationIn,
  RelationOutOutput,
  RelationsOutOutput,
  RevisionOutOutput,
  SectionIn,
  SectionOutOutput,
  SectionSaveOutOutput,
  SectionsOutOutput,
  TagOutput,
  TemplateOutOutput,
  TemplateSectionOutOutput,
} from '../generated/schemas';

export type { AssetCreateIn, AssetUpdateIn, ExpertIn, RelationIn, SectionIn } from '../generated/schemas';

export type AssetKind = AssetCreateIn['kind'];
export type AssetStatus = NonNullable<ListAssetsApiAssetsGetParams['status']>[number];
export type AssetMaturity = NonNullable<AssetCreateIn['maturity']>;
export type SectionAudience = NonNullable<SectionIn['audience']>;
export type RelationType = RelationIn['type'];
export type AssetSort = NonNullable<ListAssetsApiAssetsGetParams['sort']>;

export const ASSET_KINDS: AssetKind[] = ['platform', 'accelerator', 'framework', 'offer'];
export const ASSET_STATUSES: AssetStatus[] = ['draft', 'published', 'archived'];
export const ASSET_MATURITIES: AssetMaturity[] = ['concept', 'pilot', 'available'];

/** An id and a display name (industries, partners). */
export type Tag = TagOutput;
export type CountryTag = CountryTagOutput;
export type CatalogPerson = CatalogPersonOutput;
/** One row of `GET /api/assets`. */
export type AssetCard = AssetCardOutput;
export type AssetListOut = AssetListOutOutput;
export type ExpertOut = ExpertOutOutput;
export type SectionOut = SectionOutOutput;
export type AssetRef = AssetRefOutput;
export type RelationOut = RelationOutOutput;
export type Freshness = FreshnessOutput;
/** `GET /api/assets/{id}`: the asset as the caller may see it. */
export type AssetOut = AssetOutOutput;
export type SectionSaveOut = SectionSaveOutOutput;
export type SectionsOut = SectionsOutOutput;
export type RevisionOut = RevisionOutOutput;
export type RelationsOut = RelationsOutOutput;
export type HistoryEvent = HistoryEventOutput;
export type HistoryOut = HistoryOutOutput;
export type TemplateSectionOut = TemplateSectionOutOutput;
export type TemplateOut = TemplateOutOutput;
export type CountryCount = CountryCountOutput;
/** `GET /api/dashboard/catalog`. */
export type CatalogCard = CatalogCardOutput;

/** The catalog's query state, which `assetListSearch` writes as the `GET /api/assets` query string (SPA-side). */
export interface AssetListParams {
  q?: string;
  kind?: string[];
  status?: string[];
  maturity?: string[];
  industry?: string[];
  partner?: string[];
  country?: string[];
  stale?: boolean | null;
  sort?: AssetSort;
  order?: 'asc' | 'desc';
  page?: number;
  page_size?: number;
}
